<template>
  <div class="bg-white">
    <div class="row">
      <div class="col-12 pb-5">
        <div class="d-flex flex-column d-flex align-items-center ">

      
          <div class="progress-wrapper">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>


        </div>

      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "Loading",
  data() {
    return {
      map: null,
      google: null,
      tiles: [],
    };
  },
  async mounted() {
    
    
  },
  methods: {
    initializeMap() {
     
    }
  },
};
</script>
